export var SUCCESS_MESSAGES = {
    arrangements: {
        payment_authorization: 'Autorización de pago creada correctamente.',
        claim: 'Reclamo creado correctamente.',
        budget_request: 'Solicitud de presupuesto creada correctamente.',
        comment: 'Comentario creado correctamente.',
    },
    tickets: {
        created: 'Ticket creado correctamente.',
        internalCreated: 'Ticket interno creado correctamente.',
        createdReclamo: 'Reclamo creado correctamente.',
        updated: 'Ticket actualizado correctamente.',
        completed: 'Ticket completado correctamente.',
        assigned: 'Ticket asignado correctamente.',
    },
    ticketAlerts: {
        created: 'Alerta para tickets creada correctamente.',
        updated: 'Alerta para tickets actualizada correctamente.',
        deleted: 'Alerta para tickets eliminada correctamente.',
    },
    ticketReminders: {
        created: 'Recordatorio de ticket creado correctamente.',
        updated: 'Recordatorio de ticket actualizado correctamente.',
        deleted: 'Recordatorio de ticket eliminado correctamente.',
    },
};
export var ERROR_MESSAGES = {
    arrangements: {
        create: 'Error al crear el arreglo.',
    },
    tickets: {
        create: 'Error al crear el ticket. Por favor intenta nuevamente.',
        createReclamo: 'Error al crear el reclamo. Por favor intenta nuevamente.',
        createInternal: 'Error al crear el ticket interno. Por favor intenta nuevamente.',
        update: 'Error al guardar el ticket.',
        complete: 'Error al completar el ticket.',
        assign: 'Error al asignar el ticket.',
        modifyCompleted: 'No se puede modificar un ticket completado.',
    },
    ticketReminders: {
        create: 'Error al crear el recordatorio de ticket. Por favor intenta nuevamente.',
        update: 'Error al actualizar el recordatorio de ticket. Por favor intenta nuevamente.',
        delete: 'Error al eliminar el recordatorio de ticket. Por favor intenta nuevamente.',
    },
};
var FIELD_CONFIG = {
    title: { name: 'título', article: 'El' },
    description: { name: 'descripción', article: 'La' },
    building_id: { name: 'edificio', article: 'El' },
    provider_service: { name: 'tipo de servicio', article: 'El' },
    communication_channel: { name: 'canal de comunicación', article: 'El' },
    assignee_id: { name: 'asignado a', article: 'El' },
    status: { name: 'estado', article: 'El' },
};
var formatValidationErrors = function (errors) {
    return Object.entries(errors)
        .flatMap(function (_a) {
        var field = _a[0], messages = _a[1];
        var config = FIELD_CONFIG[field] || { name: field, article: 'El' };
        var fieldErrors = Array.isArray(messages) ? messages : [messages];
        return fieldErrors.map(function (msg) { return config.article + " " + config.name + " " + msg; });
    })
        .join(', ');
};
export var getErrorMessage = function (error, defaultMessage) {
    var _a;
    var responseData = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (responseData === null || responseData === void 0 ? void 0 : responseData.message) {
        return responseData.message;
    }
    if (responseData === null || responseData === void 0 ? void 0 : responseData.errors) {
        var validationErrors = formatValidationErrors(responseData.errors);
        if (validationErrors) {
            return defaultMessage.replace('.', '') + ": " + validationErrors + ".";
        }
    }
    return defaultMessage;
};
export var getCompletedTicketReminderWarningMessage = function (ticketNumber) {
    return "El ticket #" + ticketNumber + " est\u00E1 completado, por lo que no se pueden crear recordatorios para ese ticket.";
};
